import { useNavigate } from 'react-router-dom';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { AdvertiseLayout } from '@/components/advertise/AdvertiseLayout';
import { AdvertiseSideSummary } from '@/components/advertise/AdvertiseSideSummary';
import { AdvertiseFooterNav } from '@/components/advertise/AdvertiseFooterNav';
import { useAdvertise } from '@/store/useAdvertise';
import { useStepGuard, sellersStepValid } from '@/utils/advertiseGuards';
import { SELLERS_STEPS } from '@/config/advertiseSteps';

export default function SellersContact() {
  const navigate = useNavigate();
  const sellers = useAdvertise((s) => s.sellers);
  const setField = useAdvertise((s) => s.setField);
  useStepGuard(sellersStepValid.contact(sellers), '/advertise/sellers');

  const set = (patch) => setField('sellers', patch);
  const canProceed = sellers.firstName && sellers.lastName && sellers.email && sellers.phone;

  return (
    <AdvertiseLayout
      trackLabel="Listing Boost"
      steps={SELLERS_STEPS}
      currentStepId="contact"
      title="How can we reach you?"
      subtitle="We'll send your boost confirmation and receipt here."
      sidebar={<AdvertiseSideSummary items={[{ label: 'Name', value: [sellers.firstName, sellers.lastName].filter(Boolean).join(' ') }, { label: 'Email', value: sellers.email }]} />}
      footer={<AdvertiseFooterNav onBack={() => navigate('/advertise/sellers/details')} onNext={() => navigate('/advertise/sellers/review')} nextDisabled={!canProceed} />}
    >
      <div className="grid gap-4 sm:grid-cols-2">
        <div><Label>First name</Label><Input value={sellers.firstName} onChange={(e) => set({ firstName: e.target.value })} className="mt-1.5 rounded-xl" data-testid="sellers-contact-first-name" /></div>
        <div><Label>Last name</Label><Input value={sellers.lastName} onChange={(e) => set({ lastName: e.target.value })} className="mt-1.5 rounded-xl" data-testid="sellers-contact-last-name" /></div>
        <div><Label>Email</Label><Input type="email" value={sellers.email} onChange={(e) => set({ email: e.target.value })} className="mt-1.5 rounded-xl" data-testid="sellers-contact-email" /></div>
        <div><Label>Phone</Label><Input type="tel" value={sellers.phone} onChange={(e) => set({ phone: e.target.value })} className="mt-1.5 rounded-xl" data-testid="sellers-contact-phone" /></div>
        <div className="sm:col-span-2">
          <Label>Preferred contact method</Label>
          <RadioGroup value={sellers.contactPref} onValueChange={(v) => set({ contactPref: v })} className="mt-1.5 flex gap-4">
            <Label className="flex cursor-pointer items-center gap-2"><RadioGroupItem value="email" id="contact-pref-email" />Email</Label>
            <Label className="flex cursor-pointer items-center gap-2"><RadioGroupItem value="phone" id="contact-pref-phone" />Phone</Label>
          </RadioGroup>
        </div>
      </div>
    </AdvertiseLayout>
  );
}
